import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FaRegSave, FaTimes } from "react-icons/fa";

const styles = {
  modalContent: {
    backgroundColor: "#17296B",
  },
  avatar: {
    width: 25,
    height: 25,
    objectFit: "cover",
  },
  headerBar: {
    width: "4px",
    height: "24px",
    backgroundColor: "#0d6efd",
    borderRadius: "2px",
    marginRight: "8px",
  },
  modalOverlay: {
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 1055,
  },
  scrollArea: {
    maxHeight: "200px",
    overflowY: "auto",
  },
};

const AddDesignatedModal = ({
  show,
  onClose,
  userList,
  onSave,
  selectedDesignados,
}) => {
  const [selecionados, setSelecionados] = useState([]);
  const [disponiveis, setDisponiveis] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (show) {
      const selected = selectedDesignados || [];
      setSelecionados(selected);
      setDisponiveis(
        userList.filter((user) => !selected.some((sel) => sel.id === user.id))
      );
      setSearchTerm("");
    }
  }, [show, userList, selectedDesignados]);

  const membrosFiltrados = disponiveis.filter((m) =>
    m.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const moverParaSelecionados = (index) => {
    if (index < 0 || index >= disponiveis.length) return;
    const usuario = disponiveis[index];
    setSelecionados((prev) => [...prev, usuario]);
    setDisponiveis((prev) => prev.filter((_, i) => i !== index));
  };

  const moverParaDisponiveis = (index) => {
    if (index < 0 || index >= selecionados.length) return;
    const usuario = selecionados[index];
    setDisponiveis((prev) => [...prev, usuario]);
    setSelecionados((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = () => {
    onSave(selecionados);
    onClose();
  };

  if (!show) return null;

  return (
    <>
      <style>{`
        .table-custom {
          background-color: #17296B !important;
          color: white !important;
        }
        .table-custom tbody tr:hover {
          background-color: rgba(255, 255, 255, 0.1) !important;
        }
        .card-body-disponiveis {
          background-color: #121843 !important;
          max-height: 200px;
          overflow-y: auto;
          padding: 0.5rem;
        }
      `}</style>

      <div
        className="modal fade show d-block"
        tabIndex="-1"
        style={styles.modalOverlay}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-custom" style={styles.modalContent}>
            <div
              className="modal-header border-0 m-3"
              style={{ borderBottom: "none" }}
            >
              <h5 className="modal-title d-flex align-items-center">
                <div style={styles.headerBar} />
                Selecionar Designados
              </h5>
              <div>
                <button
                  type="button"
                  className="btn text-light mx-2"
                  style={{ backgroundColor: "#1B0F5B" }}
                  onClick={handleSave}
                >
                  <FaRegSave className="me-1" />
                  Guardar
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onClose}
                  style={{ backgroundColor: "#1B0F5B", border: "none" }}
                >
                  <FaTimes />
                </button>
              </div>
            </div>

            <div className="modal-body">
              <div className="d-flex flex-column gap-3">
                <div className="card text-white card-dark">
                  <div className="card-header border-0">Designados Selecionados</div>
                  <div
                    className="card-body p-2 scroll-area"
                    style={styles.scrollArea}
                  >
                    <table className="table table-sm table-custom mb-0">
                      <tbody>
                        {selecionados.length === 0 ? (
                          <tr>
                            <td colSpan="2" className="text-center">
                              Nenhum designado selecionado.
                            </td>
                          </tr>
                        ) : (
                          selecionados.map((user, i) => (
                            <tr key={user.id} style={{ cursor: "default" }}>
                              <td>
                                <img
                                  src={user.avatar}
                                  alt={`${user.name}`}
                                  className="rounded-circle me-2"
                                  style={styles.avatar}
                                />
                                {user.name}
                              </td>
                              <td className="text-end fs-6">
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() => moverParaDisponiveis(i)}
                                >
                                  -
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="card text-white">
                  <div className="card-header border-0 d-flex justify-content-between align-items-center">
                    <span>Designados Disponíveis</span>
                    <input
                      type="text"
                      className="form-control form-control-sm w-50"
                      placeholder="Pesquisar designado..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      autoFocus
                    />
                  </div>
                  <div className="card-body p-2 card-body-disponiveis">
                    <table className="table table-sm table-custom mb-0">
                      <tbody>
                        {membrosFiltrados.length > 0 ? (
                          membrosFiltrados.map((user) => {
                            const idx = disponiveis.findIndex(
                              (u) => u.id === user.id
                            );
                            return (
                              <tr key={user.id} style={{ cursor: "default" }}>
                                <td>
                                  <img
                                    src={user.avatar}
                                    alt={`${user.name}`}
                                    className="rounded-circle me-2"
                                    style={styles.avatar}
                                  />
                                  {user.name}
                                </td>
                                <td className="text-end">
                                  <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() => moverParaSelecionados(idx)}
                                  >
                                    +
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="2" className="text-center">
                              Nenhum designado encontrado.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

AddDesignatedModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  userList: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  selectedDesignados: PropTypes.array,
};

export default AddDesignatedModal;
